<div class="payment-pay-container theme-interface">
    <div [ngSwitch]="referenceTypeStr">
      <app-checkout-payment-order *ngSwitchCase="'ORDER'" [selectedStore]="selectedStore" [backToCurrentCat]=""></app-checkout-payment-order>
      <app-checkout-payment-standalone *ngSwitchCase="'STANDALONE_PAYMENT'" [selectedStore]="selectedStore"></app-checkout-payment-standalone>
    </div>
</div>
<app-loader></app-loader>
